import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../../Providers/ModalContext';
import Modal from '../../../../Global/Modal';
import RichText from '../../../../Global/RichText';

import CloseIcon from '../../../../../Images/icons/close-icon.png';
import BgLegal from '../../../../../Images/background/bg_cookie.png';
import BgLegalMob from '../../../../../Images/background/bg_cookie-mob.png';

import { Warning } from '../../../../../utils/ES/Footer';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalCookie = () => {
  const { closeModal } = useModal();
  const { openModal } = useModal();

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('cookieModalShown');

    if (!hasSeenModal) {
      setTimeout(() => {
        openModal('warning-modal');
        sessionStorage.setItem('cookieModalShown', 'true');
      }, 1500);
    }
  }, []);

  return (
    <>
      <Modal
        id="warning-modal"
        bgColor={'rgba(0, 0, 0, 0.7)'}
        bgContent={'rgba(0, 0, 0, 0)'}
        padding={'50px 120px 20px 120px;'}
        contentMaxWidth={'1424px'}
        contentMaxHeight={'948px'}
        bgImgContent={BgLegal}
        mobPadding={'50px 30px'}
        mobContWidth={'400px'}
        mobContHeight={'467px'}
        mobBgContImg={BgLegalMob}
      >
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <RichText dataText={Warning} />
      </Modal>
    </>
  );
};

export default ModalCookie;
